import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  typography: {
    fontFamily: [
      'Poppins',
      'sans-serif'
    ].join(','),
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 300,
    fontWeightMedium: 300,
    fontWeightBold: 700,

  },
  palette: {
    primary: {
      light: '#125095',
      main: '#125095',
      dark: '#125095',
      contrastText: '#fff',
    },
    secondary: {
      light: '#4B9FDB',
      main: '#4B9FDB',
      dark: '#4B9FDB',
      contrastText: '#fff',
    },
    info: {
      light: '#424242',
      main: '#424242',
      dark: '#424242',

      contrastText: '#fff',
    },
    background: {
      default: '#fafafa',
    },
  },
});
